export const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'true', label: 'Completed' },
  { value: 'false', label: 'Not Completed' },
];

export const NOTIFICATION_TYPE_OPTIONS = [
  { value: '', label: 'All Types' },
  { value: 'CONSENT_GRANULARITY_INVALID', label: 'Consent Granularity Invalid' },
  { value: 'INVALID_MARKET_SEGMENT', label: 'Invalid Market Segment' },
  { value: 'NO_DS_APPOINTED', label: 'No DS Appointed' },
  { value: 'NO_MS_APPOINTED', label: 'No MS Appointed' },
  { value: 'REJECTED_CONSUMPTION', label: 'Rejected Consumption' },
  { value: 'METER_FAULT', label: 'Meter Fault' },
];
